module.exports = __webpack_public_path__ + "static/scale-model-of-lyon-step-podium-in-san-francisco-california-9b584be7ed26fc73e44be78e3496f148.png";